import { Card, Skeleton, EmptyState, Badge } from '../../components/ui';
import './Buscar.css';

export default function ListaServicios({ cargando, servicios, onElegir }) {
  if (cargando) {
    return (
      <div className="buscar-dates" aria-busy="true">
        {[0, 1, 2].map((i) => (
          <Card key={i}><Skeleton width="60%" /><div style={{ height: 8 }} /><Skeleton width="40%" /></Card>
        ))}
      </div>
    );
  }

  if (!servicios) return null;

  if (servicios.length === 0) {
    return <EmptyState title="No hay servicios disponibles por el momento." />;
  }

  return (
    <div className="buscar-dates" role="radiogroup" aria-label="Servicios disponibles">
      {servicios.map((s) => (
        <Card key={`${s.nombre}-${s.tipo}`} hover as="button" onClick={() => onElegir(s)} style={{ textAlign: 'left' }}>
          <Badge tone="accent">{s.tipo}</Badge>
          <h3 style={{ margin: '10px 0 4px' }}>{s.nombre}</h3>
          <p className="buscar-muted" style={{ margin: 0 }}>Duración: {s.duracionEnMins} min</p>
        </Card>
      ))}
    </div>
  );
}